import { useState } from "react";
import { DASHBOARD_USER_TABLE_OPTIONS } from "../../../../constant";
import CustomTabs from "../../../CommonComponents/CustomTabs";
import DataTable from "../../../CommonComponents/DataTable";
import styles from "./RevenueDataTable.module.css";

const columns = [
  {
    title: "PO",
    dataIndex: "number",
    key: "number",
  },
  // {
  //   title: "Name",
  //   dataIndex: "account_name",
  //   key: "account_name",
  // },
  {
    title: "Email",
    dataIndex: "customer_email",
    key: "customer_email",
    width: "35%",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "20%",
    render: (status, record) => {
      return (
        <div className={styles[`${status.toLowerCase()}_status`]}>{status}</div>
      ); // just for decoration
    },
  },
];

const CandidatesData = [
  {
    key: "1",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Paid",
  },
  {
    key: "2",
    userID: "#702",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Paid",
  },
  {
    key: "3",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Paid",
  },
  {
    key: "4",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Overdue",
  },
  {
    key: "5",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "6",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "7",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "8",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "9",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "10",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "11",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "12",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "13",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "14",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "15",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "16",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "17",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "18",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "19",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "20",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "21",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "22",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "23",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
  {
    key: "24",
    userID: "#701",
    name: "Ben Smith",
    email: "ben@indexscore.com",
    status: "Pending",
  },
];

const EnterpriseData = [
  {
    key: "1",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "2",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "3",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "4",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "5",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "6",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "7",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "8",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "9",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "10",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "11",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "12",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "13",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "14",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "15",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "16",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "17",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "18",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "19",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "20",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "21",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "22",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "23",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
  {
    key: "24",
    userID: "#801",
    name: "John Doe",
    email: "John@test.com",
    status: "Pending",
  },
];

const RevenueDataTable = ({ data, height }) => {

  return (
    <div className={styles.content_wrap}>
      <div className={styles.content_header}>
        <div className={styles.label}>Recent Invoices</div>
      </div>
      <DataTable
        columns={columns}
        data={data?.invoicesData?.data || []}
        scroll={{
          x: "max-content",
          y: height,
        }}
      />
    </div>
  );
};

export default RevenueDataTable;
